<template>
    <div class="card-instrucoes-carregamento-pedido-andamento">
        <g-card
        :temCabecalho="false"
        :expansivel="false"
        >
            <div class="header-instrucoes-carregamento-pedido-andamento">
                <div class="header-titulo-voltar">
                    <g-button
                    class="buscar-button-header"
                    largura="35px"
                    icone="icone_voltar.svg"
                    negritoTexto
                    tamanhoIcone="10px"
                    cor="#FFFFFF"
                    altura="30px"
                    :sombreado="false"
                    @click="voltar()"
                    />

                <div class="card-titulo-instrucoes-carregamento"> Instruções de Carregamento </div>
                </div>
                <div class="print header-icons" v-tooltip="'Abre uma janela para a impressão dos detalhes do cliente!'">
                    <g-button
                    class="botoes"
                    altura="35px"
                    largura="35px"
                    tamanhoIcone="15px"
                    >
                    <i class="pi pi-print"></i>
                    </g-button>
                </div>
            </div>

            <div class="conteudo-card-instrucoes-carregamento-pedido-andamento">
                <div class="dados-instrucoes-carregamento-titulo grupo"> Dados Gerais </div>
                <div class="grupo-dados-instrucoes-carregamento topico">

                    <div class="instrucoes-carregamento-cliente">
                        <div class="titulo"> Pedido / Parcela </div>
                        <div class="conteudo"> {{this.novoPedidoDetalhes.CodigoPedido}} / {{this.novoPedidoDetalhes.NumeroParcela}} </div>
                    </div>

                    <div class="instrucoes-carregamento-unidade">
                        <div class="titulo"> Orçamento </div>
                        <div class="conteudo"> {{this.novoPedidoDetalhes.CodigoExterno}} </div>
                    </div>

                    <div class="produto-instrucoes-carregamento-produto">
                        <div class="titulo"> Produto </div>
                        <div class="conteudo"> {{this.novoPedidoDetalhes.CodigoProduto}} - {{this.novoPedidoDetalhes.NomeProduto}} </div>
                    </div>

                    <div class="instrucoes-carregamento-cv">
                        <div class="titulo"> CV </div>
                        <div class="conteudo"> {{this.novoPedidoDetalhes.CurvaClienteTexto}} </div>
                    </div>

                    <div class="instrucoes-carregamento-representante">
                        <div class="titulo"> Representante </div>
                        <div class="conteudo"> {{this.novoPedidoDetalhes.NomeRepresentante}} </div>
                    </div>

                    <div class="instrucoes-carregamento-unidade">
                        <div class="titulo"> Unidade </div>
                        <div class="conteudo"> {{this.novoPedidoDetalhes.NomeEmpresa}} </div>
                    </div>

                    <div class="instrucoes-carregamento-cliente/CNPJ">
                        <div class="titulo"> Cliente / CNPJ </div>
                        <div class="conteudo"> {{this.novoPedidoDetalhes.CodigoExternoCliente}} - {{this.novoPedidoDetalhes.NomeFantasia}} / {{this.novoPedidoDetalhes.Cnpj}} </div>
                    </div>

                    <div class="instrucoes-carregamento-tipo">
                        <div class="titulo"> Tipo </div>
                        <div class="conteudo"> {{this.novoPedidoDetalhes.TipoPedidoTexto}} </div>
                    </div>

                </div>
            </div>

            <hr>

                <div class="conteudo-card-instrucoes-carregamento-pedido-andamento">
                <div class="dados-instrucoes-carregamento-titulo grupo"> Dados sobre o Processo</div>
                <div class="grupo-dados-instrucoes-carregamento topico">

                    <div class="produto-instrucoes-carregamento-data-entrega">
                        <div class="titulo"> Data Entrega </div>
                        <div class="conteudo"> {{this.novoPedidoDetalhes.DataEntregaFormatada}} </div>
                    </div>

                    <div class="produto-instrucoes-carregamento-data-carreg">
                        <div class="titulo"> Data Carreg. </div>
                        <div class="conteudo"> {{this.novoPedidoDetalhes.DataCarregamentoFormatada}} </div>
                    </div>

                    <div class="produto-instrucoes-carregamento-data-base">
                        <div class="titulo"> Data Base </div>
                        <div class="conteudo"> {{this.novoPedidoDetalhes.DataBasePedidoParcelaFormatada}} </div>
                    </div>

                    <div class="produto-instrucoes-carregamento-oc">
                        <div class="titulo"> Ordem de Compra </div>
                        <div class="conteudo"> {{this.novoPedidoDetalhes.NumeroOrdemDeCompra || 'Não Possui'}} </div>
                    </div>

                    <div class="produto-instrucoes-carregamento-liberado">
                        <div class="titulo"> Liberado para produzir </div>
                        <div class="conteudo"> {{this.novoPedidoDetalhes.LiberadoParaProduzir == false ? 'Não' : 'Sim'}} </div>
                    </div>

                    <div class="produto-instrucoes-carregamento-qtde">
                        <div class="titulo"> Qtde </div>
                        <div class="conteudo"> {{this.novoPedidoDetalhes.QuantidadePedidoParcela}} </div>
                    </div>

                    <div class="produto-instrucoes-carregamento-qtd-produzida">
                        <div class="titulo"> Qtde Produzida </div>
                        <div class="conteudo"> {{this.novoPedidoDetalhes.QuantidadeProduzida}} </div>
                    </div>

                    <div class="produto-instrucoes-carregamento-qtd-expedida">
                        <div class="titulo"> Qtde Expedida </div>
                        <div class="conteudo"> {{this.novoPedidoDetalhes.QuantidadeExpandida}} </div>
                    </div>

                    <div class="produto-instrucoes-carregamento-componente">
                        <div class="titulo"> Componente </div>
                        <div class="conteudo">{{this.novoPedidoDetalhes.ComponenteTipoEnumTexto}} </div>
                    </div>

                    <div class="produto-instrucoes-carregamento-fase-producao">
                        <div class="titulo"> Fase de Produção </div>
                        <div class="conteudo"> 	{{this.novoPedidoDetalhes.DescricaoFaseProduto}} </div>
                    </div>
                </div>
            </div>

            <div class="conteudo-card-instrucoes-carregamento-pedido-andamento">
                <div class="dados-instrucoes-carregamento-titulo grupo"> Instruções </div>
                
                <div v-for="(instrucao, index) in instrucoesCarregamentoArray" :key="index" class="bloco-instrucao-carregamento">
                    <div class="grupo-dados-instrucoes-carregamento topico">
                        <div class="produto-instrucoes-carregamento-liberacao-carregamento">
                            <div class="titulo"> Liberação de Carregamento </div>
                            <div class="conteudo"> {{instrucao.NumeroLiberacaoCarregamento}} </div>
                        </div>

                        <div class="produto-instrucoes-carregamento-data-liberação">
                            <div class="titulo"> Data da Liberação </div>
                            <div class="conteudo"> {{instrucao.DataLiberacaoCarregamentoFormatada}} </div>
                        </div>

                        <div class="produto-instrucoes-carregamento-data-entrega">
                            <div class="titulo"> Data Entrega </div>
                            <div class="conteudo"> {{instrucao.DataCarregamentoFormatada}} </div>
                        </div>

                        <div class="produto-instrucoes-carregamento-qtde-carregada">
                            <div class="titulo"> Qtde Carregada </div>
                            <div class="conteudo"> {{instrucao.QuantidadeCarregada}} </div>
                        </div>

                        <div class="produto-instrucoes-carregamento-qtde-liberada">
                            <div class="titulo"> Qtde Liberada </div>
                            <div class="conteudo"> {{instrucao.QuantidadeLiberada}} </div>
                        </div>

                        <div class="produto-instrucoes-carregamento-oc">
                            <div class="titulo"> Ordem de Compra </div>
                            <div class="conteudo"> {{instrucao.NumeroOrdemDeCompra}} </div>
                        </div>

                        <div class="produto-instrucoes-cliente-aceita">
                            <div class="titulo"> Cliente Aceita </div>
                            <div class="conteudo"> Min: {{instrucao.NumeroMinimo}} / Max: {{instrucao.NumeroMaximo}}</div>
                        </div>

                        <div class="produto-instrucoes-carregamento-usuario">
                            <div class="titulo"> Usuário Responsável pela Liberação </div>
                            <div class="conteudo"> {{instrucao.NomeUsuario}} </div>
                        </div>
                    </div>
                    <div class="separador-instrucoes" v-if="index < instrucoesCarregamentoArray.length - 1"></div>
                </div>
                
                <!-- Fallback para exibição quando não houver array mas houver um objeto único -->
                <div v-if="instrucoesCarregamentoArray.length === 0 && this.novoInstrucoesCarregamento.NomeUsuario" class="bloco-instrucao-carregamento">
                    <div class="grupo-dados-instrucoes-carregamento topico">
                        <div class="produto-instrucoes-carregamento-liberacao-carregamento">
                            <div class="titulo"> Liberação de Carregamento </div>
                            <div class="conteudo"> {{this.novoInstrucoesCarregamento.NumeroLiberacaoCarregamento}} </div>
                        </div>

                        <div class="produto-instrucoes-carregamento-data-liberação">
                            <div class="titulo"> Data da Liberação </div>
                            <div class="conteudo"> {{this.novoInstrucoesCarregamento.DataLiberacaoCarregamentoFormatada}} </div>
                        </div>

                        <div class="produto-instrucoes-carregamento-data-entrega">
                            <div class="titulo"> Data Entrega </div>
                            <div class="conteudo"> {{this.novoInstrucoesCarregamento.DataCarregamentoFormatada}} </div>
                        </div>

                        <div class="produto-instrucoes-carregamento-qtde-carregada">
                            <div class="titulo"> Qtde Carregada </div>
                            <div class="conteudo"> {{this.novoInstrucoesCarregamento.QuantidadeCarregada}} </div>
                        </div>

                        <div class="produto-instrucoes-carregamento-qtde-liberada">
                            <div class="titulo"> Qtde Liberada </div>
                            <div class="conteudo"> {{this.novoInstrucoesCarregamento.QuantidadeLiberada}} </div>
                        </div>

                        <div class="produto-instrucoes-carregamento-oc">
                            <div class="titulo"> Ordem de Compra </div>
                            <div class="conteudo"> {{this.novoInstrucoesCarregamento.NumeroOrdemDeCompra}} </div>
                        </div>

                        <div class="produto-instrucoes-cliente-aceita">
                            <div class="titulo"> Cliente Aceita </div>
                            <div class="conteudo"> Min: {{this.novoInstrucoesCarregamento.NumeroMinimo}} / Max: {{this.novoInstrucoesCarregamento.NumeroMaximo}}</div>
                        </div>

                        <div class="produto-instrucoes-carregamento-usuario">
                            <div class="titulo"> Usuário Responsável pela Liberação </div>
                            <div class="conteudo"> {{this.novoInstrucoesCarregamento.NomeUsuario}} </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr>

            <div class="conteudo-card-instrucoes-carregamento-pedido-andamento">
                <div class="dados-instrucoes-carregamento-titulo grupo"> Clientes para Faturamento (Desdobramento) </div>
                <div class="grupo-dados-instrucoes-carregamento topico">

                    <div class="produto-instrucoes-carregamento-codigo">
                        <div class="titulo"> Código </div>
                        <div class="conteudo"> {{this.pedidoDesdobramento.ClienteCodigo}} </div>
                    </div>

                    <div class="produto-instrucoes-carregamento-nome">
                        <div class="titulo"> Nome </div>
                        <div class="conteudo"> {{this.pedidoDesdobramento.ClienteNome}} </div>
                    </div>

                    <div class="produto-instrucoes-carregamento-ordem-compra">
                        <div class="titulo"> Ordem de Compra </div>
                        <div class="conteudo"> {{this.pedidoDesdobramento.NumeroOrdemCompra}} </div>
                    </div>

                    <div class="produto-instrucoes-carregamento-obs">
                        <div class="titulo"> Observações </div>
                        <div class="conteudo"> 	{{this.pedidoDesdobramento.QuantidadeFaturar}} </div>
                    </div>
                </div>
            </div>
        </g-card>
    </div>
</template>

<script>
import InstrucoesCarregamentoPedidoCanceladosLiquidados from './InstrucoesCarregamentoPedidoCanceladosLiquidados.js'
export default InstrucoesCarregamentoPedidoCanceladosLiquidados
</script>

<style scoped>
.header-icons {
  display: flex;
  justify-self: center;
  column-gap: 5px;
}

.botoes-agrupamento{
    display: flex;
    gap: 5px;
}

.card-titulo-instrucoes-carregamento {
    color: #4f2c19;
    font-weight: bold;
    font-size: 1.3rem;
}

.grupo-dados-produto, .grupo-componentes, .grupo-observacao {
    border-bottom: none;
    border-bottom: 1px solid #e6e6e6;
    margin-top: 10px;
    column-gap: 6%;
}

.header-titulo-voltar {
  width: 100%;
  display: flex;
  align-items: flex-end;
}

.grupo {
  color: #4f2c19;
  text-align: left;
  font-family: "MontSerrat";
  font-weight: bold;
  margin-top: 30px;
  display: flex;
}

.titulo {
  color: #3e3e3e;
  text-align: left;
  font-family: "MontSerrat";
  font-weight: 500;
  margin-top: 15px;
}

.titulo-cliente{
  color: #3e3e3e;
  text-align: left;
  font-family: "MontSerrat";
  font-weight: 600;
  margin-top: 15px;
}

.conteudo {
  color: #8a8a8a;
  text-align: left;
  font-family: "MontSerrat";
  margin-bottom: 10px;
}

.titulo-instrucoes-carregamento{
    display: flex;
}


@media(min-width:310px) {
.header-instrucoes-carregamento-pedido-andamento {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
    border-bottom: 1px solid #f0f0f0;
}

.grupo {
    font-size: 18px;
}
}


@media(min-width:368px) {
.header-instrucoes-carregamento-pedido-andamento {
    grid-template-columns: 25% repeat(2, auto);
}
}


@media(min-width:600px) {
.header-instrucoes-carregamento-pedido-andamento {
    padding: 20px 0 10px;
}

.grupo-dados-produto{
    display: grid;
    grid-template-columns: repeat(2, auto);
    grid-template-rows: repeat(4, auto);
}
}


@media(min-width:801px) {
.conteudo-card-instrucoes-carregamento-pedido-andamento {
    padding: 0 30px;
}

.instrucoes-carregamento-agrupa{
    display: grid;
    grid-template-columns: repeat(2, auto);
}

.grupo-dados-instrucoes-carregamento {
display: grid;
grid-template-columns: repeat(2, auto);
grid-template-rows: repeat(4, auto);
}
}


@media(min-width:1025px) {
.conteudo-card-instrucoes-carregamento-pedido-andamento {
    padding: 0 50px;
}

.grupo-dados-produto{
    display: grid;
    grid-template-columns: repeat(4, auto);
    grid-template-rows: repeat(4, auto);
}

.instrucoes-carregamento-agrupa{
    grid-template-columns: repeat(4, auto);
}

.grupo-dados-instrucoes-carregamento {
grid-template-columns: repeat(4, auto);
}

.grupo-dados-instrucoes-carregamento, .grupo-componentes, .grupo-observacao {
    border-bottom: none;
    margin-top: 10px;
    column-gap: 2%;
}

.grupo {
    font-size: 19px;
}
}


@media(min-width:1285px) {}

@media(min-width:1500px) {}

/* Estilos para os blocos de instruções de carregamento */
.bloco-instrucao-carregamento {
    padding: 10px 0;
}

.separador-instrucoes {
    height: 1px;
    background-color: #e6e6e6;
    margin: 15px 0;
}
</style>